import * as z from "zod";
import { requiredString } from "components/form/utils";

export const contractSchema = z.object({
  status: z.string().default("draft"),
  name: requiredString(),
  type: requiredString(),
  project: requiredString()
});
